import TeenInstantPage from "../teen33/TeenInstantPage";

// casino/teen3 — reference title "Instant Teenpatti" (shared Instant Teenpatti page)
export default function TeenPatti3() {
  return <TeenInstantPage defaultType="teen3" title="Instant Teenpatti" />;
}
